module.exports = __webpack_public_path__ + "img/10.8bdb7a82.webp";